import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="page">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img 
            src={`${process.env.PUBLIC_URL}/icon.png`}
            alt="HeyGerman Logo" 
            style={{ 
              width: '60px', 
              height: '60px', 
              borderRadius: '50%',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              marginBottom: '20px'
            }} 
          />
        </div>
        <h1 style={{ textAlign: 'center', marginBottom: '40px', color: '#333' }}>
          Shipping & Delivery Policy
        </h1>
        
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ 
            padding: '30px', 
            backgroundColor: '#e8f4fd', 
            borderRadius: '10px', 
            border: '2px solid #4dabf7',
            marginBottom: '40px',
            textAlign: 'center'
          }}>
            <h2 style={{ color: '#0c5460', marginBottom: '20px', fontSize: '1.5rem' }}>
              📱 Digital Services Only
            </h2>
            <p style={{ 
              color: '#0c5460', 
              fontSize: '1.2rem', 
              fontWeight: '500', 
              lineHeight: '1.6',
              margin: 0 
            }}>
              HeyGerman provides exclusively digital educational services.<br />
              No physical products are shipped or delivered.
            </p>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Service Delivery Method</h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>💻 Online Learning Platform</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  All course materials, lessons, and resources are delivered through our secure online platform. 
                  Access is provided immediately upon successful payment and account verification.
                </p>
              </div>
              
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>📧 Email Communications</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  Course confirmations, schedules, and important updates are delivered via email to your 
                  registered email address. Please ensure your email is accurate and accessible.
                </p>
              </div>

              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>📱 Mobile Access</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  Our platform is mobile-responsive, allowing you to access your German learning materials 
                  on any device with an internet connection.
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Access & Availability</h2>
            <div style={{ padding: '20px', backgroundColor: '#d4edda', borderRadius: '8px', border: '1px solid #c3e6cb' }}>
              <div style={{ display: 'grid', gap: '15px' }}>
                <div>
                  <h3 style={{ color: '#155724', marginBottom: '8px' }}>⚡ Instant Access</h3>
                  <p style={{ color: '#155724', margin: 0, fontSize: '0.95rem' }}>
                    Digital content becomes available immediately after successful payment
                  </p>
                </div>
                <div>
                  <h3 style={{ color: '#155724', marginBottom: '8px' }}>🌍 Global Availability</h3>
                  <p style={{ color: '#155724', margin: 0, fontSize: '0.95rem' }}>
                    Access your courses from anywhere in the world with an internet connection
                  </p>
                </div>
                <div>
                  <h3 style={{ color: '#155724', marginBottom: '8px' }}>🕒 24/7 Platform Access</h3>
                  <p style={{ color: '#155724', margin: 0, fontSize: '0.95rem' }}>
                    Our learning platform is available 24 hours a day, 7 days a week
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>What You Receive</h2>
            <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
              <h3 style={{ color: '#333', marginBottom: '15px' }}>Your Digital Package Includes:</h3>
              <ul style={{ color: '#666', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Course Materials:</strong> Comprehensive German learning content and exercises
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Video Lessons:</strong> Recorded and live video sessions with instructors
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Interactive Exercises:</strong> Practice sessions and progress tracking
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Downloadable Resources:</strong> PDFs, audio files, and study materials
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Assessment Tools:</strong> Quizzes and progress evaluations
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Support Access:</strong> Direct communication channels with instructors
                </li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Technical Requirements</h2>
            <div style={{ padding: '20px', backgroundColor: '#fff3cd', borderRadius: '8px', border: '1px solid #ffeaa7' }}>
              <h3 style={{ color: '#856404', marginBottom: '15px' }}>To Access Our Services, You Need:</h3>
              <ul style={{ color: '#856404', lineHeight: '1.6', paddingLeft: '20px' }}>
                <li style={{ marginBottom: '8px' }}>Stable internet connection (broadband recommended)</li>
                <li style={{ marginBottom: '8px' }}>Modern web browser (Chrome, Firefox, Safari, Edge)</li>
                <li style={{ marginBottom: '8px' }}>Valid email address for account management</li>
                <li style={{ marginBottom: '8px' }}>Device with audio/video capabilities for interactive sessions</li>
                <li style={{ marginBottom: '8px' }}>PDF reader for downloadable materials</li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Service Issues & Support</h2>
            <div style={{ display: 'grid', gap: '15px' }}>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <h3 style={{ color: '#333', marginBottom: '8px' }}>🛠️ Technical Problems</h3>
                <p style={{ color: '#666', margin: 0, fontSize: '0.95rem' }}>
                  Contact support immediately if you experience access issues or technical difficulties
                </p>
              </div>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <h3 style={{ color: '#333', marginBottom: '8px' }}>📞 Response Time</h3>
                <p style={{ color: '#666', margin: 0, fontSize: '0.95rem' }}>
                  We aim to resolve technical issues within 24 hours of notification
                </p>
              </div>
              <div style={{ padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '8px', border: '1px solid #e9ecef' }}>
                <h3 style={{ color: '#333', marginBottom: '8px' }}>💬 Multiple Support Channels</h3>
                <p style={{ color: '#666', margin: 0, fontSize: '0.95rem' }}>
                  Reach us via email, phone, or through the platform's built-in support system
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Important Notes</h2>
            <div style={{ padding: '20px', backgroundColor: '#f8d7da', borderRadius: '8px', border: '1px solid #f5c6cb' }}>
              <ul style={{ color: '#721c24', lineHeight: '1.6', paddingLeft: '20px', margin: 0 }}>
                <li style={{ marginBottom: '10px' }}>
                  <strong>No Physical Shipping:</strong> We do not ship any physical products or materials
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Digital Delivery Only:</strong> All services and materials are delivered electronically
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>No Shipping Costs:</strong> There are no shipping, handling, or delivery fees
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Immediate Access:</strong> Services begin immediately upon successful payment
                </li>
                <li style={{ marginBottom: '10px' }}>
                  <strong>Internet Required:</strong> A reliable internet connection is essential for service access
                </li>
              </ul>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Contact Information</h2>
            <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
              <p style={{ color: '#666', marginBottom: '15px', lineHeight: '1.6' }}>
                For questions about service delivery or technical support:
              </p>
              <div style={{ display: 'grid', gap: '10px' }}>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Email:</strong> pawankumar@babycode.org
                </p>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Phone:</strong> +919030870876
                </p>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Address:</strong> 91springboard, F948+W7, Kondapur, Laxmi Cyber City, 
                  Whitefields, HITEC City, Hyderabad, Telangana 500084
                </p>
                <p style={{ color: '#666', margin: 0 }}>
                  <strong>Support Hours:</strong> Monday - Friday, 9:00 AM - 6:00 PM IST
                </p>
              </div>
            </div>
          </div>

          <div style={{ padding: '20px', backgroundColor: '#28a745', borderRadius: '8px', textAlign: 'center' }}>
            <p style={{ color: 'white', margin: 0, fontSize: '1rem', lineHeight: '1.5' }}>
              <strong>Last Updated:</strong> September 25, 2025<br />
              Digital services with instant global access and no shipping required.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;